export const consentSettings = 'consentSettings';
